var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.wrpClasses,on:{"click":_vm.toggle}},[_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.currentValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }